import { Route, Routes } from 'react-router-dom';
import { content } from '../../components/content';
import { Wrapper } from './PageDemos.style';

export type PageDemosProps = {};

export function PageDemos(_props: PageDemosProps) {
  return (
    <Wrapper className='PageDemos-wrapper' data-testid='PageDemos-wrapper'>
      <Routes>
        <Route path='/dream-builder' element={<content.DreamBuilder />} />
        <Route path='/realtime' element={<content.Realtime />} />
        <Route path='/fourth-wall' element={<content.FourthWall />} />
        <Route path='/' element={<content.FourthWall />} />
      </Routes>
    </Wrapper>
  );
}

export default PageDemos;
